import { IModalDialogOptions, WIDGET_COMPONENT } from '../../types';
import { IAppState } from '@app/store';
import { filter, includes, isEmpty, merge, startCase } from 'lodash';
import { BTN_CANCEL, BTN_DONE } from '@text-content/button-templates';
import { GRID_ROW_SELECTION } from '@geniuspos/ui-shared';
import { ICellRendererParams } from 'ag-grid-community';
import { WIDGET_FAMILY } from '@config/global-constants';
import { I18n } from '@app/i18n/strings-keys';

const incompleteTransferEventSelectorModal = (
  state: IAppState,
  filterType: string[],
): IModalDialogOptions => {
  return merge(
    {},
    {
      title: I18n.Components.EventSelectModal.EventSelector,
      validation: true,
      modalClass: `modal-lg hidden-header-checkbox`,
      buttons: [
        {
          ...BTN_DONE,
          caption: I18n.Common.SelectEvent,
          disabled: (value): boolean => isEmpty(value.events),
        },
        BTN_CANCEL,
      ],
      value: {
        events: [state.events.incompleteTransferSelectedEvents],
      },
      schema: {
        type: 'object',
        properties: {
          events: {
            type: 'array',
          },
        },
      },
      formRules: {
        fields: {
          events: {
            title: null,
            ignoreAutoTitleWhenTranslate: true,
            widgetFamily: WIDGET_FAMILY.XUX,
            widget: WIDGET_COMPONENT.grid_list,
            widgetData: {
              returnFullData: true,
              userGridOptions: {
                rowSelection: GRID_ROW_SELECTION.SINGLE,
              },
              gridHeight: '270px',
              hideActionPanel: false,
              valueField: 'id',
              selectOptions: filter(state.events.list, (item) =>
                includes(filterType, item.status),
              ),
              columns: [
                {
                  title: I18n.Components.EventSelectModal.EventName,
                  path: 'name',
                  defaultView: true,
                  sortable: false,
                  filterParams: {
                    quickFilter: true,
                  },
                },
                {
                  title: I18n.Components.EventSelectModal.EventDate,
                  path: 'date',
                  defaultView: true,
                },
                {
                  title: I18n.EntityNames.EventType,
                  path: 'event_type_entity_name',
                  defaultView: true,
                },
                {
                  title: I18n.Common.Status,
                  path: 'status',
                  defaultView: true,
                  cellRenderer: (record: ICellRendererParams): string =>
                    startCase(record?.value),
                },
              ],
            },
          },
        },
      },
    },
  );
};

export const incompleteTransferModalDefinition = {
  incompleteTransferEventSelectorModal,
};
